export function Button({ children, className = '', ...props }) {
    return (
      <button
        className={`px-4 py-2 rounded bg-green-500 text-black hover:opacity-90 ${className}`}
        {...props}
      >
        {children}
      </button>
    );
  }
  